import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

const SCALE = 10_000_000;

export const createMarketFacilitationIndex = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const greenS = readStyle(styles, "green", "#26A69A");
  const fadeS = readStyle(styles, "fade", "#9C27B0");
  const fakeS = readStyle(styles, "fake", "#795548");
  const squatS = readStyle(styles, "squat", "#2196F3");

  return {
    name: "mfi-bw",
    shortName: "BW MFI",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "mfi", title: "MFI: ", type: "bar" }],
    styles: {
      bars: [
        {
          upColor: greenS.color,
          downColor: squatS.color,
          noChangeColor: fadeS.color,
        },
      ],
    },
    regenerateFigures: () => [{ key: "mfi", title: "MFI: ", type: "bar" }],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ mfi?: number }> = new Array(n);

      for (let i = 0; i < n; i++) {
        const vol = dataList[i]!.volume || 1;
        const range = dataList[i]!.high - dataList[i]!.low;
        const mfi = (range / vol) * SCALE;
        results[i] = { mfi };
      }

      return results;
    },
  };
};
